export const getDaysLabel = (days, language = 'ua') => {
    let label = '';

    // Перевіряємо мову і використовуємо відповідну форму для "день"
    switch(language) {
        case 'ru':
            if (days % 10 === 1 && days % 100 !== 11) {
                label = `${days} день`;
            } else if ((days % 10 >= 2 && days % 10 <= 4) && (days % 100 < 10 || days % 100 >= 20)) {
                label = `${days} дня`;
            } else {
                label = `${days} дней`;
            }
            break;
        case 'en':
            label = `${days} day${days !== 1 ? 's' : ''}`;
            break;
        case 'ua':
        default:
            if (days % 10 === 1 && days % 100 !== 11) {
                label = `${days} день`;
            } else if ((days % 10 >= 2 && days % 10 <= 4) && (days % 100 < 10 || days % 100 >= 20)) {
                label = `${days} дні`;
            } else {
                label = `${days} днів`;
            }
            break;
    }

    return label;
}

export const getHoursLabel = (hours, language = 'ua') => {
    let label = '';

    // Перевіряємо мову і використовуємо відповідну форму для "година"
    switch(language) {
        case 'ru':
            if (hours % 10 === 1 && hours % 100 !== 11) {
                label = `${hours} час`;
            } else if ((hours % 10 >= 2 && hours % 10 <= 4) && (hours % 100 < 10 || hours % 100 >= 20)) {
                label = `${hours} часа`;
            } else {
                label = `${hours} часов`;
            }
            break;
        case 'en':
            label = `${hours} hour${hours !== 1 ? 's' : ''}`;
            break;
        case 'ua':
        default:
            if (hours % 10 === 1 && hours % 100 !== 11) {
                label = `${hours} година`;
            } else if ((hours % 10 >= 2 && hours % 10 <= 4) && (hours % 100 < 10 || hours % 100 >= 20)) {
                label = `${hours} години`;
            } else {
                label = `${hours} годин`;
            }
            break;
    }

    return label;
}

export const getMinutesLabel = (minutes, language = 'ua') => {
    let label = '';

    // Перевіряємо мову і використовуємо відповідну форму для "хвилина"
    switch(language) {
        case 'ru':
            if (minutes % 10 === 1 && minutes % 100 !== 11) {
                label = `${minutes} минута`;
            } else if ((minutes % 10 >= 2 && minutes % 10 <= 4) && (minutes % 100 < 10 || minutes % 100 >= 20)) {
                label = `${minutes} минуты`;
            } else {
                label = `${minutes} минут`;
            }
            break;
        case 'en':
            label = `${minutes} minute${minutes !== 1 ? 's' : ''}`;
            break;
        case 'ua':
        default:
            if (minutes % 10 === 1 && minutes % 100 !== 11) {
                label = `${minutes} хвилина`;
            } else if ((minutes % 10 >= 2 && minutes % 10 <= 4) && (minutes % 100 < 10 || minutes % 100 >= 20)) {
                label = `${minutes} хвилини`;
            } else {
                label = `${minutes} хвилин`;
            }
            break;
    }

    return label;
}